import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { RoleSchema } from '@fhnw/schemas/role';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Lecturers),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['randomSort', 'lecturers'],
    },
  ],
  properties: {
    randomSort: {
      title: intl.formatMessage(messages.RandomSort),
      description: intl.formatMessage(messages.RandomSortHelp),
      type: 'boolean',
    },
    lecturers: {
      title: intl.formatMessage(messages.Lecturers),
      description: intl.formatMessage(messages.LecturersHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: RoleSchema({
              intl,
              fields: ['contact', 'displayName', 'description', 'link'],
            }),
          },
        },
      },
      default: [],
    },
  },
  required: [],
});

export default Schema;
